import { Component, Input } from '@builder.io/sdk';

import moleculeAwardsFields from 'molecules/Awards/config';
import { moleculeHeadingFields } from 'molecules/Heading/config';
import sectionFields from 'molecules/Section/config';

const awardsFields = [
  ...moleculeHeadingFields,
  ...sectionFields,
  ...moleculeAwardsFields(),
] as const satisfies DeepReadonly<Input[]>;

export const awardsConfig = {
  name: 'awards',
  inputs: awardsFields,
} satisfies Component;

export type AwardsConfigProps = GenerateBuilder<typeof awardsFields>;
